// Angular
import { CommonModule, DecimalPipe, registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Core
import { CoreModule } from "./_core/core.module";
import { HighlightSearchPipe } from "./_core/pipes/highlight-search.pipe";
import { NumberSuffixPipe } from "./_core/pipes/number-suffix.pipe";

// Models

// Material
import { CdkTableModule } from "@angular/cdk/table";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

// import ngx-translate and the http loader
import { HttpClient } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Shared
import { HeaderComponent } from "../../src/app/modules/shared/header/header.component";
import { CommandPaletteDialogComponent } from "./modules/shared/components/command-palette/command-palette-dialog.component";
import { LayoutComponent } from "./modules/shared/layout/layout.component";

import { ErrorComponent } from "./modules/shared/error/error.component";
import { ErrorLayoutComponent } from "./modules/shared/error-layout/error-layout.component";

// Locale settings
import localeEs from "@angular/common/locales/es";

// Components
import { AuthService } from "./_core/providers/auth.service";
import { ApplicationDialogComponent } from "./modules/main/components/dialogs/application-dialog/application-dialog.component";
import { NoDigitDecimaNumberDirective } from "./modules/shared/directives/no-decimal-digit-number.directive";
import { TwoDigitDecimaNumberDirective } from "./modules/shared/directives/two-decimal-digit-number.directive";
import { LoaderComponent } from "./modules/shared/loader/loader.component";
import { BreadcrumbsComponent } from "./modules/shared/breadcrumbs/breadcrumbs.component";
import { UserSearchComponent } from "./modules/shared/components/user-search/user-search.component";
import { DsAutocompleteComponent } from "./modules/form-controls/components/ds-autocomplete/ds-autocomplete.component";
import { DsTabLabelComponent } from "./modules/shared/components/ds-tab-label/ds-tab-label.component";
import { EmpleadoAvatarComponent } from "./modules/form-controls/components/empleado-avatar/empleado-avatar.component";
import { CountryComponent } from "./modules/shared/components/country/country.component";
import { LanguageSelectorDialogComponent } from "./modules/shared/components/language-selector-dialog/language-selector-dialog.component";

registerLocaleData(localeEs, "es");

export function getConfigFromServer(config: AuthService) {
	return () => config.initializeAuth();
}

@NgModule({ declarations: [
        NumberSuffixPipe,
        HighlightSearchPipe,
        LayoutComponent,
        HeaderComponent,
        CommandPaletteDialogComponent,
        BreadcrumbsComponent,
        ErrorComponent,
        ErrorLayoutComponent,
        LoaderComponent,
        ApplicationDialogComponent,
        TwoDigitDecimaNumberDirective,
        NoDigitDecimaNumberDirective,
        UserSearchComponent,
        LanguageSelectorDialogComponent,
    ],
    exports: [
        DecimalPipe,
        UserSearchComponent,
        DsTabLabelComponent,
        CountryComponent,
        EmpleadoAvatarComponent,
        NumberSuffixPipe,
        HighlightSearchPipe,
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatDialogModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatTableModule,
        CdkTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSortModule,
        MatMenuModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatChipsModule,
        MatTreeModule,
        MatProgressSpinnerModule,
        TwoDigitDecimaNumberDirective,
        NoDigitDecimaNumberDirective,
    ], imports: [CommonModule,
        CountryComponent,
        DsAutocompleteComponent,
        DsTabLabelComponent,
        EmpleadoAvatarComponent,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatDialogModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatTabsModule,
        MatTableModule,
        CdkTableModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSortModule,
        MatMenuModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatChipsModule,
        MatTreeModule,
        MatProgressSpinnerModule], providers: [DecimalPipe, NumberSuffixPipe, HighlightSearchPipe, provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule {}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
